module.exports = __webpack_public_path__ + "img/bar1.5f011091.png";